import 'angular:locale/data:bs';
import 'angular:locale/data:sr-Latn';
import 'angular:locale/data:tr';
import 'angular:locale/data:en';
import 'angular:locale/data:de';(globalThis.$localize ??= {}).locale = "___NG_LOCALE_INSERT___";
